import { proxy, transfer, wrap } from 'comlink';
const LOG_PREFIX = '[RecordingCaptureManager]';
/**
 * Main-thread side of the recorder. One recording worker per page: it
 * outlives the broadcast session, because a recording is still uploading
 * after the broadcast has ended.
 */
export class RecordingCaptureManager {
    static instance;
    static getInstance() {
        RecordingCaptureManager.instance ??= new RecordingCaptureManager();
        return RecordingCaptureManager.instance;
    }
    worker;
    api;
    ensureWorker() {
        if (!this.api) {
            this.worker = new Worker(new URL('./RecordingWorker.ts', import.meta.url), { type: 'module', name: 'recordingWorker' });
            this.api = wrap(this.worker);
            console.log(`${LOG_PREFIX} worker spawned`);
        }
        return this.api;
    }
    /** `tapPort` is the receiving end of the networking worker's tap. */
    async start(options, tapPort, onState) {
        await this.ensureWorker().start(options, transfer(tapPort, [tapPort]), proxy(onState));
    }
    /** Gives the running recording `recordingId` its picture for listings. */
    async setThumbnail(recordingId, jpeg) {
        await this.api?.setThumbnail(recordingId, jpeg);
    }
    async setLive(live) {
        await this.api?.setLive(live);
    }
    async stop() {
        await this.api?.stop();
    }
    async resume(credentials, onState) {
        return this.ensureWorker().resume(credentials, proxy(onState));
    }
    /** Recordings the worker has not finished uploading. */
    async getWorkingCount() {
        return (await this.api?.getWorkingCount()) ?? 0;
    }
}
